import { useQuery } from '@apollo/client/react';
import { type CO2CalculationsQuery, CO2CalculationsDocument } from 'graphql/generated/graphql';

const useGetCO2Calculations = (
  projectId: string,
): [CO2CalculationsQuery['co2Calculations'] | undefined, boolean] => {
  const { data, loading } = useQuery(CO2CalculationsDocument, { variables: { projectId } });
  return [data?.co2Calculations, loading];
};

export default useGetCO2Calculations;
